const ACTIONS = {
    SETTINGS: "settings"
}

export default ACTIONS;